import { reports } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getReportsList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(reports.base, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getReportTypeOptions(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(reports.options, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createReportObject(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${reports.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  downloadReport(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${reports.base}${id}/download/`, { responseType: "blob" })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.tripReports, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOrderReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.orderReports, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDailyOrderReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.dailyOrderReports, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverAttendanceReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.driverAttendanceReports, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverExpenseReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.driverExpenseReports, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getVehicleReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.vehicleReports, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getVehicleKilometerReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.vehicleKmReports, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getVehicleOdometerReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.vehicleOdometerReports, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getVehicleOrderDeliveryReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.vehicleOrderDeliveryReports, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getFleetUtilizationReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.fleetUtilizationReport, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getOperationSummaryReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.operationSummaryReport, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverTripReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.driverTripReports, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDriverOrderDeliveryReportData(params, headers) {
    let options = {
      params: params,
    };
    if (headers && Object.keys(headers).length > 0) {
      options.headers = headers;
      options.responseType = "blob";
    }
    return new Promise((resolve, reject) => {
      axios
        .get(reports.driverOrderDeliveryReports, options)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
